class CookiesPolicy extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const policyElement = this.querySelector('#cookiesPolicy');

    // Check if cookie is already set
    if (this.getCookie('cookiesDirective')) {
      this.style.display = 'none';
      return;
    }

    // Show the policy with slide up animation
    this.style.display = 'block';

    // Trigger slide up animation after a brief delay
    setTimeout(() => {
      if (policyElement) {
        policyElement.classList.add('slide-up');
      }
    }, 100);

    // Attach close button event
    const closeBtn = this.querySelector('.cookies-policy--close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.handleClose());
    }
  }

  handleClose() {
    const policyElement = this.querySelector('#cookiesPolicy');

    // Slide down animation
    if (policyElement) {
      policyElement.classList.remove('slide-up');
      policyElement.classList.add('slide-down');

      // Wait for animation to complete before hiding
      setTimeout(() => {
        this.style.display = 'none';
      }, 400); // Match the CSS transition duration
    }

    // Set cookie for 365 days
    this.setCookie('cookiesDirective', '1', 365);
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value}${expires}; path=/`;
  }
}

if (!customElements.get('cookies-policy')) {
  customElements.define('cookies-policy', CookiesPolicy);
}